<template>
  <div class="header-container">
    <div class="m-2">
      <h3 class="header-text">{{ $t('header.title') }}</h3>
      <div class="header-component">
        <b-form-datepicker
          class="m-4 datepicker"
          :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"
          :placeholder="$t('common.selectDate')"
          calendar-width="350px"
          :min="minDate"
          :max="maxDate"
          :locale="language"
          v-model="selectedDate"
          dropright>
        </b-form-datepicker>
      </div>
    </div>
    <Ad placementName="video" class="video-ad m-2"/>
  </div>
</template>

<script>
import Ad from './Ad.vue'

export default {
  name: 'TerrorZoneHeader',

  components: {
    Ad,
  },

  data() {
    return {
      selectedDate: '',
      selectedTimestamp: null,
    }
  },

  props: {
    language: {
      type: String
    },

    isOnlineMode: {
      type: Boolean
    },
  },

  computed: {
    minDate () {
      return this.isOnlineMode ? new Date(2023, 10, 1) : new Date(2023, 1, 1);
    },

    maxDate () {
      return this.isOnlineMode ? new Date() : new Date(2025, 12, 31);
    },
  },

  watch: {
    selectedDate(newDate) {
      if (newDate) {
        const date = new Date(newDate);
        this.selectedTimestamp = date.getTime() + date.getTimezoneOffset() * 60 * 1000;
        this.$emit('change-date', this.selectedTimestamp);
      } else {
        this.selectedTimestamp = null;
        this.$emit('change-date', null);
      }
    },
  },
}
</script>

<style scoped>
.header-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.header-component {
  display: flex;
  align-items: center;
  justify-content: center;
}
.header-text {
  margin-top: auto;
  margin-bottom: auto;
  color: #ddd;
}
.datepicker {
  max-width: 800px;
}
.video-ad {
  max-width: 400px;
}
@media (max-width: 800px) {
  .header-container {
    flex-direction: column;
  }
  .video-ad {
    max-width: 800px;
  }
}
</style>
